export default {
    getToken() {
        const data = window.location.search.match(/.*?report=([a-zA-Z0-9_-]+).*?/);

        if (data) {
            return data[1];
        }
    }
};


// WEBPACK FOOTER //
// ./src/services/TokenService.js